import {
  FETCH_VEHICLE_BODYTYPES_DATA,
  FETCH_VEHICLE_BODYTYPES_SUCCESS,
  FETCH_VEHICLE_BODYTYPES_FAILURE,
  FETCH_VEHICLE_BODYTYPES_EDIT_DATA,
  FETCH_VEHICLE_BODYTYPES_EDIT_SUCCESS,
  FETCH_VEHICLE_BODYTYPES_EDIT_FAILURE,
} from "./actionTypes";

const initialState = {
  loading: false,
  data: null,
  error: null,
  edit: {
    loading: false,
    data: null,
    error: null,
  },
};

const vehicleBodyTypes = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_VEHICLE_BODYTYPES_DATA:
      return { ...state, loading: true, error: null };
    case FETCH_VEHICLE_BODYTYPES_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_VEHICLE_BODYTYPES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case FETCH_VEHICLE_BODYTYPES_EDIT_DATA:
      return { ...state, edit: { loading: true, data: null, error: null } };
    case FETCH_VEHICLE_BODYTYPES_EDIT_SUCCESS:
      return { ...state, edit: { loading: false, data: action.payload, error: null } };
    case FETCH_VEHICLE_BODYTYPES_EDIT_FAILURE:
      return { ...state, edit: { loading: false, data: null, error: action.payload } };

    default:
      return state;
  }
};

export default vehicleBodyTypes;
